// extracted by css-extract-rspack-plugin
module.exports =  {"statList":"CX353"};